export { metadataConfig, metadataConfigObject } from './utils/metadataConfig';
